export const htmlDecode = (input: any) => {
  input = input || ''
  try {
    var doc = new DOMParser().parseFromString(input, 'text/html')
    return doc.documentElement.textContent
  } catch (e) {
    console.error(e)
    return input
  }
}

export const unEntity = (str: string) => {
  str = str || ''
  return str.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>')
}

let prevUrl : string | undefined = ''
let prevUrlFull = ''
let runningScrollToTop = false
export const scrollToTop = (retryAttempt: number = 0) => {
  if (runningScrollToTop) return
  runningScrollToTop = true
  setInterval(() => {
    let addressFull = window.location.href
    let addressNoHash = addressFull.split('#')[0]
    if (prevUrl == '' || addressFull.includes('#')) {
      prevUrl = addressNoHash
      prevUrlFull = addressFull
      return
    }

    if (prevUrlFull != addressFull) {
      prevUrl = addressNoHash
      prevUrlFull = addressFull
      setTimeout(() => {
        window.scrollTo(0, -50)
      }, 100)
      return
    }
  }, 500)
}

let runningScrollToHash = false
let currentGlobalHash = ''
export const scrollToHash = () => {
  if (runningScrollToHash) return
  runningScrollToHash = true
  setInterval(() => {
    let hash = window.location.hash != undefined ? window.location.hash : undefined

    if (hash == currentGlobalHash) {
      return
    }

    if (hash != '' && hash != undefined) {
      currentGlobalHash = hash
      let q = document.querySelector(`[id*=${hash?.substring(1) || ''}]`)
      let element: HTMLElement = q !== null ? q : (null as any)

      if (element == null) {
        currentGlobalHash = ''
        return
      }

      if (element !== null) {
        setTimeout(() => {
          console.log('scrolling to hash element')
          element.scrollIntoView({
            block: 'start'
          })
        }, 500)
      }
    }
  }, 500)
}
